<template>
  <article class="fluid-block">
    <div class="fluid-block__inner-wrapper">
      <slot />
    </div>
  </article>
</template>

<script>
export default {}
</script>

<style lang="scss">
.fluid-block {
  $this: &;

  box-shadow: $box-shadow-primary;

  @include font(text, 3, "normal");

  &__inner-wrapper {
    border-radius: 4px;
    background: $color-white;
    padding: 1rem;

    h3 {
      @include font(rubrik, 2, "bold");

      padding: 0;
    }

    hr {
      display: block;
      border: none;
      border-top: 1px solid $color-grey-special;
      width: 100%;
      margin: 0;
      height: 1px;
    }
  }
}
</style>
